    (function ($) {
        'use strict';
        $.fn.modalActionsExceptions = function (options) {

            const settings = $.extend({
                ctaAddToCart: '[onclick*="addProductToCart"]',
                ctaAddToCartStarter: '.addToCartStarter',
                tabClose: null,
                tabsType: null,
                autofocus: false
            }, options);

            return this.each(function () {

                const $self = $(this);
                if (!isCartAvailable) {
                    $self.find(settings.ctaAddToCart).attr({
                        'data-tab-close': settings.tabClose,
                        'data-tabs-type': settings.tabsType,
                        'data-autofocus': settings.autofocus
                    });
                }

                if (!isAuthenticated) {
                    $self.find(settings.ctaAddToCartStarter).attr({
                        'data-tab-close': settings.tabClose,
                        'data-tabs-type': settings.tabsType,
                        'data-autofocus': settings.autofocus
                    });
                }
            });
        }
    })(jQuery);